import { BaseObject } from "@adgate/common/types/base-object.type";

export class CommercialOffice extends BaseObject
{
    externalId!: string;
}
